export enum BrandEnum {
  CJ_MORE = 'CJ_MORE',
  CJX = 'CJX'
}

export const BRAND_LOV = [
  {
    value: BrandEnum.CJ_MORE,
    label: 'CJ MORE',
    logo: 'assets/images/brand/cj-more.svg'
  },
  {
    value: BrandEnum.CJX,
    label: 'CJx',
    logo: 'assets/images/brand/cjx.svg'
  }
];
